<template>
  <div class="mainBox">
    <el-page-header @back="goBack" content="详情页面"> </el-page-header>
    <br />
    <el-alert title="注：本表请于每周二、五中午12:00之前提报。" type="warning"> </el-alert>
    <el-form label-width="100px" style="display: block !important">
      <br />
      <el-row
        :gutter="0"
      >
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="所属省区：">
            <el-input v-model="name" placeholder="请填写"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="采集人：">
            <el-input v-model="name" placeholder="请填写"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="采集渠道：">
            <el-input v-model="name" placeholder="请填写"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="客户名称：">
            <el-input v-model="name" placeholder="请填写"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <br />
          <el-card class="box-card">
              <span>43度</span>
              <el-button
                @click="typeIn(1)"
                type="primary"
                icon="el-icon-edit"
                style="float: right; padding: 6px 18px"
                round
                >填写</el-button
              >
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <br />
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>精品茅台酒</span>
              <el-button
                @click="typeIn(1)"
                type="primary"
                icon="el-icon-edit"
                style="float: right; padding: 6px 18px"
                round
                >填写</el-button
              >
            </div>
            <div v-for="o in 4" :key="o" class="text item">
              {{ "库存数： " + o }}
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <br />
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>鼠（牛）年生肖茅台酒</span>
              <el-button
                @click="typeIn(1)"
                type="primary"
                icon="el-icon-edit"
                style="float: right; padding: 6px 18px"
                round
                >填写</el-button
              >
            </div>
            <div v-for="o in 4" :key="o" class="text item">
              {{ "库存数： " + o }}
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <br />
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>陈年茅台酒（15年）</span>
              <el-button
                @click="typeIn(1)"
                type="primary"
                icon="el-icon-edit"
                style="float: right; padding: 6px 18px"
                round
                >填写</el-button
              >
            </div>
            <div v-for="o in 4" :key="o" class="text item">
              {{ "库存数： " + o }}
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <br />
    <div style="text-align: center">
      <el-button
        @click="typeIn(1)"
        type="primary"
        icon="el-icon-edit"
        round
        style="width: 360px"
        >提交</el-button
      >
    </div>
    <br />
    <br />
    <br />

    <el-dialog
      title="填写内容"
      :visible.sync="dialogVisible"
      width="500px"
      max-width="200px"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="上期结余库存数：">
          <el-input v-model="name" placeholder="瓶"></el-input>
        </el-form-item>
        <el-form-item label="统计期内到货数：">
          <el-input v-model="name" placeholder="瓶"></el-input>
        </el-form-item>
        <el-form-item label="统计期内销货数：">
          <el-input v-model="name" placeholder="箱"></el-input>
        </el-form-item>
        <el-form-item label="统计期内销货数：">
          <el-input v-model="name" placeholder="瓶"></el-input>
        </el-form-item>
        <el-form-item label="本期结余库存数：">
          <el-input v-model="name" placeholder="瓶"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Get_Table_Data } from "@/api/aTable/aTable.js";

export default {
  data() {
    return {
      activeNames: ["1"],
      dialogVisible: false,
    };
  },
  methods: {
    goBack() {
      console.log("go back");
    },
    handleChange(val) {
      console.log(val);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    typeIn(itemId) {
      this.dialogVisible = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
//<!--3.1、样式区-->
<style type="text/css" scoped>
.mainBox {
  max-width: 1000px;
  margin: 0px auto 10px auto;
  background-color: #fffdf7;
  border-style: dotted;
  border-width: thin;
  padding: 10px 30px;
  border-color: gainsboro;
  border-radius: 10px;
}
/**控制本页边界 */
.el-form-item {
  margin-bottom: 10px !important;
}
.el-table .cell {
  line-height: 14px !important;
}
.el-divider--horizontal {
  margin: 10px 0 !important;
}
.el-dialog__body {
  padding: 0px 20px 20px 20px !important;
}
/**解决form无高度问题 */
.el-form {
  display: inline-block !important;
}
.el-table--mini th,
.el-table--mini td {
  padding: 0px !important;
}
.el-table--small th,
.el-table--small td {
  padding: 4px !important;
}
.el-table .cell {
  line-height: 16px !important;
}
.el-divider--horizontal {
  margin: 12px 0px !important;
}
.el-card {
  border-radius: 16px !important;
  /* //background-color: #fdfbf8 !important; */
  box-shadow: 1px 1px 2px #888888;
}
.el-dialog {
  border-radius: 16px !important;
}
.light:hover {
  color: red !important;
}
.el-badge__content.is-fixed {
  z-index: 20 !important;
}
</style>
<style type="text/css">
.el-dialog {
  border-radius: 12px !important;
}
</style>


// WEBPACK FOOTER //
// src/api/pageTwo/pageTwo.vue